import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "match-modal" }
const _hoisted_2 = { class: "match-modal__section" }
const _hoisted_3 = { class: "match-modal__section-title" }
const _hoisted_4 = { class: "match-modal__selected-summary" }
const _hoisted_5 = { class: "match-modal__selected-item-value" }
const _hoisted_6 = { class: "match-modal__selected-item-label" }
const _hoisted_7 = { class: "match-modal__selected-item-value" }
const _hoisted_8 = { class: "match-modal__selected-item-label" }
const _hoisted_9 = { class: "match-modal__selected-item-value" }
const _hoisted_10 = { class: "match-modal__selected-item-label" }
const _hoisted_11 = { class: "match-modal__selected-item-value" }
const _hoisted_12 = { class: "match-modal__selected-item-value" }
const _hoisted_13 = { class: "match-modal__selected-item-value" }
const _hoisted_14 = { class: "match-modal__selected-item-value" }
const _hoisted_15 = { class: "match-modal__selected-item-value" }
const _hoisted_16 = { class: "match-modal__selected-item-value" }
const _hoisted_17 = { class: "match-modal__selected-item-value" }
const _hoisted_18 = { class: "match-modal__section" }
const _hoisted_19 = { class: "match-modal__section-title" }
const _hoisted_20 = { class: "match-modal__search" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "match-modal__table-wrapper" }
const _hoisted_23 = ["checked", "value", "onChange"]
const _hoisted_24 = {
  key: 0,
  class: "match-modal__section"
}
const _hoisted_25 = { class: "match-modal__section-title" }
const _hoisted_26 = { class: "match-modal__preview" }
const _hoisted_27 = { class: "match-modal__preview-row" }
const _hoisted_28 = { class: "match-modal__preview-label" }
const _hoisted_29 = { class: "match-modal__preview-before" }
const _hoisted_30 = {
  key: 0,
  class: "match-modal__preview-arrow"
}
const _hoisted_31 = {
  key: 1,
  class: "match-modal__preview-after"
}
const _hoisted_32 = { class: "match-modal__preview-row" }
const _hoisted_33 = { class: "match-modal__preview-label" }
const _hoisted_34 = { class: "match-modal__preview-before" }
const _hoisted_35 = {
  key: 0,
  class: "match-modal__preview-arrow"
}
const _hoisted_36 = {
  key: 1,
  class: "match-modal__preview-after"
}
const _hoisted_37 = { class: "match-modal__preview-row" }
const _hoisted_38 = { class: "match-modal__preview-label" }
const _hoisted_39 = { class: "match-modal__preview-before" }
const _hoisted_40 = {
  key: 0,
  class: "match-modal__preview-arrow"
}
const _hoisted_41 = {
  key: 1,
  class: "match-modal__preview-after"
}
const _hoisted_42 = { class: "match-modal__preview-row" }
const _hoisted_43 = { class: "match-modal__preview-label" }
const _hoisted_44 = { class: "match-modal__preview-before" }
const _hoisted_45 = {
  key: 0,
  class: "match-modal__preview-arrow"
}
const _hoisted_46 = {
  key: 1,
  class: "match-modal__preview-after"
}
const _hoisted_47 = { class: "match-modal__preview-row" }
const _hoisted_48 = { class: "match-modal__preview-label" }
const _hoisted_49 = { class: "match-modal__preview-before" }
const _hoisted_50 = {
  key: 0,
  class: "match-modal__preview-arrow"
}
const _hoisted_51 = {
  key: 1,
  class: "match-modal__preview-after"
}
const _hoisted_52 = { class: "match-modal__preview-row" }
const _hoisted_53 = { class: "match-modal__preview-label" }
const _hoisted_54 = { class: "match-modal__preview-before" }
const _hoisted_55 = {
  key: 0,
  class: "match-modal__preview-arrow"
}
const _hoisted_56 = {
  key: 1,
  class: "match-modal__preview-after"
}

import { i18n } from '@/i18n';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import { useUnmatchedOrderStore } from '../pages/useUnmatchedOrderStore';
import type { UnmatchedOrderItem } from '../domains/entities/UnmatchedOrderItem';
import { DateService } from '@/coreDomainsModule/services/dateService';
import OrderStatusBadge from '@/corePagesModule/components/OrderStatusBadge.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MatchConfirmModal',
  props: {
    modalState: { type: Boolean },
    checkedItems: {}
  },
  emits: ["canceled", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const t = i18n.t;
const store = useUnmatchedOrderStore();
const { state, filteredExistingOrders, selectedExistingOrder } = storeToRefs(store);

const existingOrderColumns = [
  '32px',
  '120px',
  '120px',
  '120px',
  '120px',
  '120px',
  '120px',
  '80px',
  '120px',
  '120px',
  '120px',
  '120px',
  '120px',
  '80px',
  '120px',
];

const existingOrderTableLoadingStatus = computed(() => {
  if (filteredExistingOrders.value.length === 0 && state.value.matchSearchKeyword) {
    return { type: 'zero-match' as const };
  }
  return { type: 'success' as const };
});

const isConfirmDisabled = computed(() => !state.value.selectedExistingOrderId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState,
    "modal-width": 1280,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('突合する'),
    "is-disabled-next-button": isConfirmDisabled.value,
    "enable-outside-click": true,
    "is-disabled-scroll": true,
    onOnBack: _cache[1] || (_cache[1] = ($event: any) => (emits('canceled'))),
    onOnNext: _cache[2] || (_cache[2] = ($event: any) => (emits('confirm')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('既存発注との突合')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('選択した')) + _toDisplayString(_ctx.checkedItems.length) + _toDisplayString(_unref(t)('件の未照合データを既存発注と照合します。突合先の発注を選択してください。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('未照合データ（選択中）')), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkedItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.unmatchedOrderId,
                class: "match-modal__selected-item"
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('置場コード')) + _toDisplayString(':\n') + _toDisplayString(item.warehouseNumber || '--'), 1),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('置場名')) + _toDisplayString(':\n') + _toDisplayString(item.warehouse || '--'), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('仕入先コード')) + _toDisplayString(':\n') + _toDisplayString(item.supplierNumber || '--'), 1),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('仕入先名')) + _toDisplayString(':\n') + _toDisplayString(item.supplierName || '--'), 1),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('商品コード')) + _toDisplayString(':\n') + _toDisplayString(item.businessNumber || '--'), 1),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('商品名')) + _toDisplayString(':\n') + _toDisplayString(item.businessName || '--'), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('容量')) + _toDisplayString(':\n') + _toDisplayString(item.package || '--'), 1),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('発注番号')) + _toDisplayString(':\n') + _toDisplayString(item.orderNumber || '--'), 1),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('発注作成日')) + " " + _toDisplayString(':\n') + " " + _toDisplayString(item.createdOrderDate ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(item.createdOrderDate) : '--'), 1),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('希望納期')) + " " + _toDisplayString(':\n') + " " + _toDisplayString(item.desiredDeliveryDate ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(item.desiredDeliveryDate) : '--'), 1),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('納期')) + " " + _toDisplayString(':\n') + " " + _toDisplayString(item.estimatedTimeOfArrival ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(item.estimatedTimeOfArrival) : '--'), 1),
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('発注数量')) + _toDisplayString(':\n') + _toDisplayString(item.orderAmount || '--'), 1),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "match-modal__selected-item-separator" }, "/", -1)),
                _createElementVNode("span", _hoisted_17, [
                  _createTextVNode(_toDisplayString(_unref(t)('ステータス')) + _toDisplayString(':\n'), 1),
                  _createVNode(OrderStatusBadge, {
                    "order-status-str": item.orderStatus
                  }, null, 8, ["order-status-str"])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('突合先の既存発注を選択')), 1),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).matchSearchKeyword) = $event)),
              type: "text",
              class: "match-modal__search-input",
              placeholder: _unref(t)('仕入先名・商品名・発注番号で検索')
            }, null, 8, _hoisted_21), [
              [_vModelText, _unref(state).matchSearchKeyword]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(EzTable, {
              "grid-template-columns": existingOrderColumns,
              "loading-status": existingOrderTableLoadingStatus.value,
              "sticky-header": "",
              "max-height": "300px"
            }, {
              header: _withCtx(() => [
                _createVNode(EzHeader, { "force-center": "" }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode(" ")
                  ]), undefined, true),
                  _: 1,
                  __: [15]
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('倉庫CD')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('倉庫名')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('仕入先CD')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('仕入先名')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('商品CD')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('商品名')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('容量')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('発注管理番号')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('発注番号')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('発注作成日')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('希望納期')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('納期')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('発注数量')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('ステータス')), 1)
                  ], undefined, true),
                  _: 1
                })
              ]),
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredExistingOrders), (order) => {
                  return (_openBlock(), _createBlock(EzTableRow, {
                    key: order.orderId,
                    "grid-template-columns": existingOrderColumns,
                    "is-highlighted": _unref(state).selectedExistingOrderId === order.orderId,
                    class: "match-modal__order-row",
                    onClick: ($event: any) => (_unref(store).selectExistingOrder(order.orderId))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(EzCell, {
                        "force-center": "",
                        class: "match-modal__radio-cell"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "radio",
                            class: "match-modal__radio",
                            checked: _unref(state).selectedExistingOrderId === order.orderId,
                            value: order.orderId,
                            name: "existingOrder",
                            onChange: ($event: any) => (_unref(store).selectExistingOrder(order.orderId))
                          }, null, 40, _hoisted_23)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.warehouseNumber), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.warehouse), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.supplierNumber), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.supplierName), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.businessNumber), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.businessName), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, { "is-number": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.package), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.orderIssuedNumber || '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.orderNumber || '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.createdOrderDate ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(order.createdOrderDate) : '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(order.desiredDeliveryDate)), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(order.estimatedTimeOfArrival)), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, { "is-number": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.orderAmount.addComma()), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(EzCell, null, {
                        default: _withCtx(() => [
                          _createVNode(OrderStatusBadge, {
                            "order-status-str": order.orderStatus
                          }, null, 8, ["order-status-str"])
                        ], undefined, true),
                        _: 2
                      }, 1024)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["is-highlighted", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading-status"])
          ])
        ]),
        (_unref(selectedExistingOrder))
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('反映内容プレビュー')), 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('発注番号')), 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(selectedExistingOrder).orderNumber || '--'), 1),
                  (_ctx.checkedItems[0]?.orderNumber !== _unref(selectedExistingOrder).orderNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, "→"))
                    : _createCommentVNode("", true),
                  (_ctx.checkedItems[0]?.orderNumber !== _unref(selectedExistingOrder).orderNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.checkedItems[0]?.orderNumber || '--'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('作成日')), 1),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(selectedExistingOrder).createdOrderDate
                  ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(_unref(selectedExistingOrder).createdOrderDate)
                  : '--'), 1),
                  (_ctx.checkedItems[0]?.createdOrderDate && _ctx.checkedItems[0]?.createdOrderDate !== _unref(selectedExistingOrder).createdOrderDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, " → "))
                    : _createCommentVNode("", true),
                  (_ctx.checkedItems[0]?.createdOrderDate && _ctx.checkedItems[0]?.createdOrderDate !== _unref(selectedExistingOrder).createdOrderDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(_ctx.checkedItems[0]?.createdOrderDate)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('希望納期')), 1),
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(_unref(selectedExistingOrder).desiredDeliveryDate)), 1),
                  (
                _ctx.checkedItems[0]?.desiredDeliveryDate && _ctx.checkedItems[0]?.desiredDeliveryDate !== _unref(selectedExistingOrder).desiredDeliveryDate
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, " → "))
                    : _createCommentVNode("", true),
                  (
                _ctx.checkedItems[0]?.desiredDeliveryDate && _ctx.checkedItems[0]?.desiredDeliveryDate !== _unref(selectedExistingOrder).desiredDeliveryDate
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(_ctx.checkedItems[0]?.desiredDeliveryDate)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(t)('納期')), 1),
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(_unref(selectedExistingOrder).estimatedTimeOfArrival)), 1),
                  (
                _ctx.checkedItems[0]?.estimatedTimeOfArrival &&
                _ctx.checkedItems[0]?.estimatedTimeOfArrival !== _unref(selectedExistingOrder).estimatedTimeOfArrival
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, " → "))
                    : _createCommentVNode("", true),
                  (
                _ctx.checkedItems[0]?.estimatedTimeOfArrival &&
                _ctx.checkedItems[0]?.estimatedTimeOfArrival !== _unref(selectedExistingOrder).estimatedTimeOfArrival
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(_ctx.checkedItems[0].estimatedTimeOfArrival)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(t)('発注数量')), 1),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(selectedExistingOrder).orderAmount), 1),
                  (_ctx.checkedItems[0]?.orderAmount && _ctx.checkedItems[0]?.orderAmount !== _unref(selectedExistingOrder).orderAmount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, " → "))
                    : _createCommentVNode("", true),
                  (_ctx.checkedItems[0]?.orderAmount && _ctx.checkedItems[0]?.orderAmount !== _unref(selectedExistingOrder).orderAmount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.checkedItems[0]?.orderAmount), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(t)('発注ステータス')), 1),
                  _createElementVNode("span", _hoisted_54, [
                    _createVNode(OrderStatusBadge, {
                      "order-status-str": _unref(selectedExistingOrder).orderStatus
                    }, null, 8, ["order-status-str"])
                  ]),
                  (_ctx.checkedItems[0]?.orderStatus && _ctx.checkedItems[0]?.orderStatus !== _unref(selectedExistingOrder).orderStatus.toString())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_55, " → "))
                    : _createCommentVNode("", true),
                  (_ctx.checkedItems[0]?.orderStatus && _ctx.checkedItems[0]?.orderStatus !== _unref(selectedExistingOrder).orderStatus.toString())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                        _createVNode(OrderStatusBadge, {
                          "order-status-str": _ctx.checkedItems[0]?.orderStatus
                        }, null, 8, ["order-status-str"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})